import { useQuery } from '@tanstack/react-query';
import { API } from '../utils/Api';
import { Plan } from '../models/core';
import { ListResponse } from '../utils/SharedAPI';

const fetchQuery = async (clientId: string): Promise<ListResponse<Plan>> => {
    return await API.getPlans(clientId);
};

export const usePlanQuery = (clientId: string|undefined) => {
    return useQuery<ListResponse<Plan>, Error>({
        queryKey: ['plans', clientId],
        queryFn: () => fetchQuery(clientId||''),
        enabled: !!clientId,
        staleTime:(60*8)*1000
    });
};